export const strings = {
  home: {
    title: 'Tooling Management Group',
    description1: '"The preferred operations, warehousing, and technology solutions provider"',
    description2:
      'TMG provides specialized services to automotive manufacturers that enhance service part outcomes. Our delivery model integrates experienced personnel, processes refined over decades, and advanced technology into your supply chain or manufacturing operations. TMG will consistently produce results and with our shared-success framework, elevate your profitability in tandem with improved operations.',
  },
  aboutUs: {
    title: 'Our Founding Values',
    pillar1: {
      title: 'Trustworthiness',
      text: 'We do it right. Tooling records disappear. Audit responses get scrambled. Disposition requests stall for months at other firms. TMG was built to fix exactly that. We bring decades of hands-on automotive tooling expertise to every engagement, and we do the full job, from the floor-level physical inventory to the clean, accurate data that flows upstream to your OEM. Our track record of success has been built across 1,000+ supplier sites. We perform bottoms-up, 4-wall physical inventories, not desk reviews, so the data is real.',
    },
    pillar2: {
      title: 'Ownership',
      text: "Leave tooling to us. TMG was created specifically because automotive tooling was being underserved. Too niche, too hands-on, too easy to deprioritize. We took ownership of that gap and built a company around it. That same mindset carries through to every client engagement. We don't hand you a report and leave. We manage the process end-to-end: physical inventory, data reconciliation, disposition submissions, service tooling part production, scrap coordination, warehousing, and trucking. Whatever the tooling problem requires, we own it through to resolution.",
    },
    pillar3: {
      title: 'Flexibility',
      text: "A targeted solution for your problems. No two plants are organized the same way. Supplier sites have different systems, different histories, different levels of data readiness and OEM requirements vary by customer. TMG doesn't apply a rigid methodology and hope it fits. We pace our work to match your team's availability. We built ToolSight to match each client's specific workflow, easily customizable to configure for your operation. And when the scope changes mid-engagement, we adapt without starting over.",
    },
  },

  services: {
    title: 'Services',
    blurb:
      'Tooling data is difficult to manage across decades long tool lifecycles, for OEMs and Tier 1 suppliers alike. TMG focuses on the post production stages, and ToolSight keeps the data connected throughout.',
    toolsight: {
      name: 'ToolSight.',
      tagline: 'TMG-configured platform',
      inputsLabel: 'Inputs',
      coreLabel: 'One data model',
      coreSub: 'one login \u00b7 one URL',
      outputsLabel: 'Outputs',
      note: 'Manages tooling data across the full lifecycle. Inputs and outputs are customized around the core platform, available per plant, by subscription with unlimited users.',
    },
  },
  valueDelivered: {
    title: 'Value Delivered',
  },
  contact: {
    title: 'Contact',
    tagline: 'Have a tooling challenge? We want to hear about it.',
    name: 'Chris Ongena',
    role: 'CEO, Tooling Management Group',
    emailLink: 'mailto:chris@toolingmanagementgroup.com',
    email: 'chris@toolingmanagementgroup.com',
    address: '745 State Circle, Ann Arbor, MI 48108, USA',
  },
  footer: {
    company: 'Tooling Management Group',
    copyright: 'Copyright © 2025 All rights reserved',
  },
};
